import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './index.css';
import { initClarity } from './shared/analytics/clarity';
import { initSentry } from './shared/analytics/sentry';

// Register auth adapters (port-adapter pattern)
import { setAuthTokenProvider } from './shared/api/auth-token-provider';
import { firebaseTokenAdapter } from './features/auth/services/firebase-token-adapter';
import { setAuthService } from './features/auth/ports/auth-service.registry';
import { firebaseAuthAdapter } from './features/auth/adapters/firebase-auth.adapter';

setAuthTokenProvider(firebaseTokenAdapter);
setAuthService(firebaseAuthAdapter);

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);

// Initialize analytics
initClarity();
initSentry();
